import {Api,handleResponse,handleError} from '../../../../../../api';
//Action
const Actions = {
    CreateFolder: 'inner/create-folder',
}


export const apiRequest = {
    createFolder
};

async function createFolder(parent,model) {
    const { onRefresh } = parent.props;
    await new Api().call.post(Actions.CreateFolder, model).then(handleResponse)
        .then(res => {
            parent.setState({
                response:res,
                loading:false
            });
            onRefresh();
        }).catch(error=>{
            if(error!=null && error!==undefined && error.response!==null && error.response!==undefined){
                parent.setState({
                    response:error.response.data,
                    loading:false
                });
            }
            else{
                parent.setState({
                    response:{message:'Váratlan hiba történt',type:'error'},
                    loading:false
                });
            }
            handleError(error);
        });
}